export enum LoanProjectionChartColors {
	LIGHT_GREEN = '#8e2679',
	DARK_GREEN = '#595da4',
	ORIGINAL_BG = '#ededed',
	ORIGINAL_BORDER = '#a3a3a4',
	LIGHT_GRAY = '#5176b1',
	DARK_GRAY = '#595da4',
}
